import CtaLink from './CtaLink';

const trustPoints = [
  'Built for Companies Doing $300,000 or More Annually',
  'Roofers • HVAC • Hardscape / Landscape',
  'Real Campaign Results & Proven Growth Systems',
  'Direct Strategy With Josh Hastings',
];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative overflow-hidden pt-28 md:pt-40 pb-16 md:pb-24">
      {/* Background gradient glows */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -left-24 w-[480px] h-[480px] rounded-full bg-primary-500/10 blur-[120px] animate-glow-pulse" />
        <div className="absolute top-1/3 -right-24 w-[420px] h-[420px] rounded-full bg-background-300/50 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — copy */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-400"></span>
              Growth Systems for Home Service Businesses
            </span>

            <h1 className="mt-6 font-heading font-bold text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-foreground-950">
              I Help Home Service Businesses Turn{' '}
              <span className="text-primary-400">
                Marketing Dollars Into Measurable Leads, Customers & Revenue
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              Hey, my name is Josh Hastings, and over the last decade I have
              helped established local-service and home-service businesses
              create predictable growth and scale past $1,000,000 through
              smarter marketing systems, lead generation, follow-up, and
              business strategies.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <CtaLink>Apply to Work With Me</CtaLink>
              <CtaLink href="#leads-system" variant="secondary">
                See My Growth System
              </CtaLink>
            </div>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {trustPoints.map((t) => (
                <li key={t} className="flex items-center gap-2.5">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span className="text-sm text-foreground-700">{t}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right — portrait */}
          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/20 via-transparent to-background-300/40 blur-2xl" />
            <div className="relative rounded-2xl overflow-hidden border border-white/10">
              <div className="relative w-full aspect-[4/5]">
                <img
                  src="/assets/images/joshuaw-hastings.jpg"
                  alt="Josh Hastings, home service growth strategist"
                  title="Josh Hastings — Home Service Growth Strategist"
                  className="absolute inset-0 opacity-70 w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3 rounded-lg bg-background-50/70 backdrop-blur-md border border-white/10 px-4 py-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-950">
                  <i className="ri-verified-badge-line text-lg"></i>
                </span>
                <div>
                  <p className="font-heading font-semibold text-sm text-foreground-950">
                    Josh Hastings
                  </p>
                  <p className="text-xs text-foreground-600">
                    Home Service Growth Strategist
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
